"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsService = void 0;
const lists_1 = require("src/lists");
const search_1 = require("src/search");
const FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
const String_utils_1 = require("src/String.utils");
const filtersConfig_1 = require("../filtersConfig");
const src_1 = require("src");
class SearchResultsService {
    static isSegmentFilterOfAnyType(type) {
        return (type === FullTextSearchApi_1.FullTextSearchFilters.AllSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.DocumentationSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.ProductsSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.DownloadSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.CourseSegmentFilterAlias ||
            type === FullTextSearchApi_1.FullTextSearchFilters.DrawingsSegmentFilterAlias);
    }
    static getDocumentSearchPageTypeFromUrl() {
        const type = src_1.UrlService.GetFilterQueryValueFromUrl('type');
        switch (type) {
            case FullTextSearchApi_1.FullTextSearcherTypes.Documentation:
                return FullTextSearchApi_1.FullTextSearcherTypes.Documentation;
                break;
            case FullTextSearchApi_1.FullTextSearcherTypes.Drawings:
                return FullTextSearchApi_1.FullTextSearcherTypes.Drawings;
                break;
        }
    }
}
exports.SearchResultsService = SearchResultsService;
SearchResultsService.hasGroupFilterTemplate = (filterId) => {
    return !!filtersConfig_1.GROUP_FILTER_TEMPLATE_BY_FILTER_ID[filterId];
};
SearchResultsService.hasGroupFilterItemTemplate = (groupTemplate, filterType) => {
    return !!SearchResultsService.getGroupFilterItemTemplate(groupTemplate, filterType);
};
SearchResultsService.getGroupFilterItemTemplate = (groupTemplate, filterType) => {
    return (0, lists_1.getFirstOrDefault)(groupTemplate.filters, null, template => {
        return (0, String_utils_1.equalIgnoreCase)(filterType, template.type);
    });
};
SearchResultsService.getGroupFilterTemplateByFilterId = (filterId) => {
    const template = filtersConfig_1.GROUP_FILTER_TEMPLATE_BY_FILTER_ID[filterId];
    return template || null;
};
SearchResultsService.getFilterOrderByTypeFilterAndId = (typeFilterValue, filterId) => {
    const filtersMappingByType = filtersConfig_1.FILTER_ORDER_MAPPING[typeFilterValue];
    const FALLBACK_ORDER = Infinity;
    return filtersMappingByType && filtersMappingByType[filterId]
        ? filtersMappingByType[filterId]
        : FALLBACK_ORDER;
};
SearchResultsService.getFilterValueFromQuery = (filter, selectedValues, filterId) => {
    // Get facet languages from query
    const queryValues = SearchResultsService.getValuesFromQuery(filter.query, filterId);
    // Get language value
    let result;
    if (filter.selected) {
        result = (0, lists_1.getFirstOrDefault)(selectedValues, null, item => queryValues && queryValues.indexOf(item) === -1);
    }
    else {
        result = (0, lists_1.getFirstOrDefault)(queryValues, null, item => !selectedValues || selectedValues.indexOf(item) === -1);
    }
    return result;
};
SearchResultsService.getValuesFromQuery = (query, filterName) => {
    return query
        .split('&')
        .filter(item => {
        const keyValue = item.split('=');
        return keyValue.length === 2 && keyValue[0] === `${search_1.FACET_PREFIX}${filterName}`;
    })
        .map(item => {
        return item.split('=')[1];
    });
};
SearchResultsService.getFilterKeyItself = (filterValue, separator = ':') => filterValue ? filterValue.split(separator)[0] : '';
SearchResultsService.getFilterValueItself = (filterValue, separator = ':') => filterValue ? filterValue.split(separator)[1] : '';
